import React from 'react';
import { NavBar, Footer } from 'components';
import { makeStyles } from '@material-ui/core';


interface IProps {
    children: React.ReactNode
}

const useStyles = makeStyles(theme => ({
    content: {
        marginBottom: theme.spacing(2)
    }
}))

let ErrorLayout = ({ children }: IProps) => {
    let classes = useStyles();

    return (
        <>
            <NavBar />
            <div className={classes.content}>
                {children}
            </div>
            <Footer />
        </>
    )
}

export default ErrorLayout;